import { render, staticRenderFns } from "./_base-resource-cover.vue?vue&type=template&id=7f7e0a0a&scoped=true"
import script from "./_base-resource-cover.vue?vue&type=script&setup=true&lang=js"
export * from "./_base-resource-cover.vue?vue&type=script&setup=true&lang=js"
import style0 from "./_base-resource-cover.vue?vue&type=style&index=0&id=7f7e0a0a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f7e0a0a",
  null
  
)

export default component.exports